/* @flow */
import * as React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import type { Location, RouterHistory } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import ToolbarSearchBox from '../../../components/ToolbarSearchBox';
import actions from '../../../redux/actions';
import { getTrackSearchParams } from '../../../redux/reducers/trackSearch';
import { getMediaSearchParams } from '../../../redux/reducers/mediaSearch';
import protonesUtils from '../../../utils/protones';

import type {
  SearchField,
  SearchFilter,
  SearchParams,
  ReduxState,
  TrackSearchParams,
  MediaSearchParams,
} from '../../../types';

const mapStateToProps = (state: ReduxState, ownProps) => {
  return {
    ...ownProps,
    params: state.app.searchParams,
    paramsHistory: state.app.searchHistory,
    trackSearchParams: getTrackSearchParams(state),
    mediaSearchParams: getMediaSearchParams(state),
  };
};

type Props = {
  placeholder: string,
  params: SearchParams,
  paramsHistory: SearchParams[],
  setSearch: typeof actions.setSearch,
  performMediaSearch: typeof actions.performMediaSearch,
  performTrackSearch: typeof actions.performTrackSearch,
  trackSearchParams: TrackSearchParams,
  mediaSearchParams: MediaSearchParams,
  onSearchSubmit: (params: SearchParams) => any,
  location: Location,
  history: RouterHistory,
};

class HeaderSearchBar extends React.Component<Props, void> {
  _updateSearch = (params: SearchParams) => {
    switch (this.props.location.pathname) {
      case '/medias/search': {
        this.props.performMediaSearch(_.merge({}, this.props.mediaSearchParams, params));
        protonesUtils.goTo(this.props, protonesUtils.routes.medias.find());
        return;
      }
      default: {
        this.props.performTrackSearch(_.merge({}, this.props.trackSearchParams, params));
        protonesUtils.goTo(this.props, protonesUtils.routes.tracks.find());
      }
    }
  };

  _performNewSearch = (params: SearchParams) => {
    this.props.performMediaSearch(_.merge({ categoryIds: [] }, params));

    if (JSON.stringify({ text: '', flags: {}, filters: {} }) !== JSON.stringify(params))
      protonesUtils.goTo(this.props, protonesUtils.routes.medias.find());

    this.props.performTrackSearch(_.merge({}, params));
    if (JSON.stringify({ text: '', flags: {}, filters: {} }) !== JSON.stringify(params))
      protonesUtils.goTo(this.props, protonesUtils.routes.tracks.find());
  };

  _handleSearchTextChange = (text: string) => {
    this.props.setSearch({ categoryIds: [], text, flags: {}, filters: {} });
  };

  _handleSearchReset = () => {
    this._performNewSearch({ text: '', flags: {}, filters: {} });
  };

  _handleSearchFlagsUpdate = (flags: { [SearchField]: boolean }) => {
    this._updateSearch({
      ...this.props.params,
      flags,
    });
  };

  _handleSearchFiltersUpdate = (filters: { [SearchFilter]: string[] }) => {
    this._updateSearch({
      ...this.props.params,
      filters,
    });
  };

  render() {
    return (
      <>
        <ToolbarSearchBox
          placeholder={this.props.placeholder}
          params={this.props.params}
          paramsHistory={this.props.paramsHistory}
          onChange={this._handleSearchTextChange}
          onFlagsUpdate={this._handleSearchFlagsUpdate}
          onFiltersUpdate={this._handleSearchFiltersUpdate}
          onSearchReset={this._handleSearchReset}
          onSubmit={this.props.onSearchSubmit}
        />
      </>
    );
  }
}

export default withRouter(connect(mapStateToProps, actions)(HeaderSearchBar));
